
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { Period } from '@/store/modules/periods/state';
import i18n from '@/i18n';
import { TranslateResult } from 'vue-i18n';

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    currentPeriod: {
      type: Object as Vue.PropType<Period>,
      required: true,
    },
  },
  computed: {
    totalOfPeriods(): number {
      return this.periods.length;
    },
    totalOfAvailablePeriods(): number {
      return this.periods.filter((period) => !period.blocked).length;
    },
    currentPeriodIndex(): number {
      return this.periods.findIndex((period) => period.number === this.currentPeriod.number);
    },
    periods(): Period[] {
      return this.$store.getters.userPeriods;
    },
    modalTitle(): TranslateResult {
      if (this.shouldDisplayPeriodsRenamed) {
        return i18n.t('modules');
      }

      return i18n.t('periods');
    },
    shouldDisplayPeriodsRenamed(): boolean {
      return this.$store.getters.shouldDisplayPeriodsRenamed;
    },
  },
  methods: {
    closeMenu(): void {
      this.$emit('closeMenu');
    },
    changePeriod(index: number): void {
      if (index < 0 || index >= this.periods.length) {
        return;
      }

      if (this.periods[index].blocked) {
        return;
      }

      this.$store.commit('SET_USER_CURRENT_PERIOD', this.periods[index]);
      this.closeMenu();
    },
    isPeriodActive(index: number): boolean {
      return this.currentPeriodIndex === index;
    },
  },
});
